module.exports = __webpack_public_path__ + "img/51842cb.png";